<template>
    <rkm-row>
        <rkm-col>
            <rkm-row>
                <rkm-col cols="12">
                    <BoxProcedimento :item="item" />
                </rkm-col>
            </rkm-row>

            <rkm-row>
                <rkm-col cols="12">
                    <BoxObservacao :item="item" />
                </rkm-col>
            </rkm-row>

            <rkm-row>
                <rkm-col cols="12">
                    <BoxInformacaoAdministrativa :item="item" />
                </rkm-col>
            </rkm-row>
        </rkm-col>
    </rkm-row>
</template>

<script>
// Components.
import BoxInformacaoAdministrativa from './components/informacao-administrativa/Index'
import BoxObservacao from './components/observacao/Index'
import BoxProcedimento from './components/procedimento/Index'

export default {
    components: {
        BoxInformacaoAdministrativa,
        BoxObservacao,
        BoxProcedimento,
    },
    props: {
        item: {type: Object, required: true},
    },
}
</script>